import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInWithRedirect,
  signInWithPopup,
  GoogleAuthProvider,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword
} from 'firebase/auth';

import {
  getFirestore , doc, getDoc , setDoc
} from 'firebase/firestore'
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
const firebaseConfig = {
  apiKey: "AIzaSyAHru_3Iz_bVl9jnSd7LYAqLpO_qAnB9dA",
  authDomain: "reham-clothing.firebaseapp.com",
  projectId: "reham-clothing",
  storageBucket: "reham-clothing.appspot.com",
  messagingSenderId: "256358339116",
  appId: "1:256358339116:web:b1085406db782a2f8b3789"
};
const app = initializeApp(firebaseConfig);
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account',
});
export const createUserProfileDocument = async (userAuth, additionalData) => {
  if (!userAuth) return;
  console.log(userAuth);
};
export const auth = getAuth();
export const signInWithGooglePopup = () => signInWithPopup(auth, googleProvider);
export const signInWithGoogleRedirect =()=>signInWithRedirect(auth,googleProvider);

export const db = getFirestore();
export const createUserDocumentFromAuth = async (userAuth, additionalinfo={})=>{
 
  if(!userAuth) return;
  const userDocRef = doc(db,'users', userAuth.uid);
  console.log(userDocRef);
  const userSnapshot = await getDoc(userDocRef);
  console.log("user = ",userSnapshot);
  // console.log("exists ? ",userSnapshot.exists());

    if(!userSnapshot.exists()){ // false
      const {displayName,email} = userAuth;
      const createdAt = new Date();
      try{
        await setDoc(userDocRef,{
          displayName, email, createdAt, ...additionalinfo
      });
      }catch(err){
        console.log('error creating the user',err.message);
      }
    }
    return userDocRef;
}
//-----------------------------------------
export const createAuthUserWithEmailAndPassword = async(email, password)=>{
  if(!email || !password) return;
  return await createUserWithEmailAndPassword(auth, email , password);
}
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
export const signInAuthUserWithEmailAndPassword = async(email, password)=>{
  if(!email || !password) return;
  return await signInWithEmailAndPassword(auth, email , password);
}
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx